import { EChatV2Status, IChatV2Schema } from '@cian/chats-api';

import { mapOfferV2VersionToV1 } from './mapOffer';
import { mapUserV2VersionToV1 } from './mapUser';
import { TChatDataInListSchema } from '../../types/chatList';

export const mapChatV2VersionToV1 = (chat: IChatV2Schema): TChatDataInListSchema => {
  const updatedMs = new Date(chat.datetimeForSorting).getTime();

  return {
    archived: chat.status === EChatV2Status.Archived,
    availableActions: chat.availableActions,
    blocked: chat.status === EChatV2Status.Blocked,
    chatId: chat.chatId,
    created: updatedMs,
    createdMs: updatedMs,
    customActions: chat.customActions,
    data: {
      offer: mapOfferV2VersionToV1(chat.offer),
    },
    deleted: chat.status === EChatV2Status.Deleted,
    description: chat.description,
    lastMessage: chat.lastMessage,
    title: '',
    type: chat.type,
    unread: chat.unreadMessagesCount,
    updated: updatedMs,
    updatedMs,
    users: chat.users.map(mapUserV2VersionToV1),
    withModerator: false,
  };
};
